<template>
  <b-container style="margin-top: -30px; margin-bottom: 20px">
    <b-row>
      <b-col>
        <InfoMediaAvailable :available-to="mediaAvailableTo" :last-stay-deletion-date="lastStayDeletionDate"
                            v-if="mediaAvailableTo"/>
        <InfoHdAvailable :hd-available-to="hdAvailableTo"
                         v-else-if="hdAvailableTo && showOldMessages"/>
        <InfoSdHdAvailable :hd-available-to="hdAvailableTo"
                         v-else-if="hdAvailableTo && !showOldMessages"/>
        <InfoMediaDeleted v-else-if="mediaDeleted"/>
      </b-col>
    </b-row>
  </b-container>
</template>


<script>
import InfoMediaDeleted from "@/domain/checkin/components/mediaInfo/InfoMediaDeleted.vue";
import InfoMediaAvailable from "@/domain/checkin/components/mediaInfo/InfoMediaAvailable.vue";
import {mapGetters} from "vuex";
import InfoHdAvailable from "@/domain/checkin/components/mediaInfo/InfoHdAvailable.vue";
import InfoSdHdAvailable from "@/domain/checkin/components/mediaInfo/InfoSdHdAvailable.vue";

export default {
  name: "InfosMedia",
  components: {InfoSdHdAvailable, InfoHdAvailable, InfoMediaAvailable, InfoMediaDeleted},
  computed: {
    ...mapGetters('checkinDetail', [
      'hdAvailableTo',
      'mediaAvailableTo',
      'mediaDeleted',
      'lastStayDeletionDate']),
    showOldMessages() {
      return new Date(this.hdAvailableTo).toDateString() <= new Date('2024-05-26').toDateString()
    },
  },

}
</script>

<style scoped>

</style>